import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import AppRouter from './AppRouter';
import 'App.css';

class App extends Component {
  render() {
    return (
      <Provider store={this.props.store}>
        <AppRouter />
      </Provider>
    );
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired,
};

export default App;
